<template>
  <div class="m-0 p-0 date-picker-wrapper">
    <Field
      :name="name"
      :rules="validation"
      v-slot="{ field, errors, meta }"
    >
      <label v-if="labelOnTop" :style="labelOnTopStyle" class="input-label">
        {{$t(label)}}
        <span v-if="validation.includes('required')">*</span>
        <span v-else>{{$t('(optional)')}}</span>
      </label>
      <VueDatePicker
        auto-apply
        :offset="0"
        v-bind="field"
        v-model="localValue"
        :placeholder="$t(placeholder)"
        :max-date="maxDate"
        :min-date="minDate"
        :enable-time-picker="false"
        :action-row="{ showSelect: false, showCancel: false }"
        :format="params?.format || 'dd/mm/yyyy'"
        :ui="{ input: 'date-input' }"
        :class="{
          'is-invalid': meta.touched && errors.length,
        }"
        :start-date="startDate"
      />
      <span v-if="meta.touched && errors.length" class="text-red-500 text-sm">
        {{ errors[0] }}
      </span>
    </Field>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { Field } from 'vee-validate';
import { parse, format } from 'date-fns'

export default {
  name: "date-input",
  components: {
    VueDatePicker,
    Field
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    modelValue: {
      type: Date,
      default: null
    },
    validation: {
      type: String,
      required: false
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    params: {
      type: Object,
      required: false
    },
    labelOnTop: {
      type: Boolean,
      default: false
    },
    labelOnTopStyle: {
      type: Object,
      default: () => {}
    },
    cookieName: {
      type: String,
      required: false,
      default: () => ""
    },
  },
  mounted () {
    if (this.cookieName) {
      const userInfo = this.$cookies.get("oktaUser");
      if (userInfo && userInfo[this.cookieName]) {
        this.localValue = parse(userInfo[this.cookieName], 'yyyy-mm-dd', new Date())
      } else {
        this.localValue = this.modelValue;
      }
    } else {
      this.localValue = this.modelValue;
    }
  },
  computed: {
    maxDate () {
      const from = this.params?.disabledDates?.from
      if (typeof from === 'number') {
        const date = new Date()
        date.setFullYear(date.getFullYear() - from)
        return date // maximum date = youngest acceptable age
      }
      return null
    },

    minDate () {
      const to = this.params?.disabledDates?.to
      if (typeof to === 'number') {
        const date = new Date()
        date.setFullYear(date.getFullYear() - to)
        return date // minimum date = oldest acceptable age
      }
      return null
    },

    startDate() {
      if (this.localValue) return this.localValue;
      if (this.maxDate) return this.maxDate;
      if (this.minDate) return this.minDate;
    }
  },
  data () {
    return {
      localValue: null,
    }
  },
  watch: {
    localValue (newValue) {
      const formattedValue = format(new Date(newValue), 'yyyy-MM-dd')
      this.$emit("component-updated", {
        value: formattedValue,
      });
    }
  },
};
</script>

<style scoped lang="scss">

.date-input {
	background: #FFFFFF;
  border: 1px solid var(--input-border-color) !important;
  box-sizing: border-box;
  border-radius: 8px;
  transition: border-color 0.15s;
  height: 48px !important;
}
:deep(.dp__menu) {
  min-width:350px !important;
  @media (max-width:450px) {
    min-width:250px !important;
  }
}

:deep(.dp__arrow_top) {
  display: none !important;
}

:deep(.dp__pointer) {
  height: 48px !important;
}
.date-picker-wrapper{
  @media (max-width:992px) {
    margin-bottom: 20px !important;
  }
}
:deep(.dp__input_wrap) {
  transition: all 0.2s ease;
}

:deep(.dp__input_wrap:hover) {
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
}

:deep(.dp__input_wrap:focus-within) {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.4);
  border-color: #3b82f6;
  outline: none;
}

:deep(.dp__input) {
  outline: none;
}

:deep(.dp__input:focus) {
  outline: none;
}
</style>
